











import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import SettingListProfile from '@/components/molecules/SettingListProfile.vue'
import SettingListItem from '@/components/molecules/SettingListItem.vue'
import SettingListTwitter from '@/components/molecules/SettingListTwitter.vue'
import { State as UsersState } from '@/store/modules/users'

export default Vue.extend({
  name: 'Settings',
  components: {
    PageTitle,
    SimpleLoader,
    SettingListProfile,
    SettingListItem,
    SettingListTwitter
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.users.isProfileLoading
    },
    profile(): UsersState['profile'] | null {
      return this.$state.users.profile
    }
  },
  methods: {
    execRouterPush(route: string) {
      this.$router.push(route)
    },
    onfocus() {
      this.$store.dispatch('users/fetchProfile')
    }
  },
  mounted() {
    this.$store.dispatch('users/fetchProfile')
    window.onfocus = this.onfocus
  },
  destroyed() {
    window.removeEventListener('onfocus', this.onfocus)
  }
})
